import { render, staticRenderFns } from "./NewContactModal.vue?vue&type=template&id=290bbb70&"
import script from "./NewContactModal.vue?vue&type=script&lang=ts&"
export * from "./NewContactModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports